export default {
  service: {
    title: 'خدماتي',
    subtitle: 'يمكنك الوصول إلى جميع منصاتك',
    otherAvailable: 'جميع الخدمات المتاحة',
    access: 'الوصول إلى هذه الخدمة',
    enable: 'تفعيل هذه الخدمة',
    moreService: 'عرض جميع خدماتي',
    dialogContent: {
      content: 'للوصول إلى هذه الخدمة، يجب عليك الاتصال بفريق الدعم على الرقم 01 23 45 67 89 أو عبر البريد الإلكتروني على Loremipsum{\'@\'}dolor.sit',
      subtitle: 'الوصول إلى خدمة جديدة'
    },
    legalMentions: 'الإشعارات القانونية',
    eula: 'الشروط العامة',
    endUserLicenseAgreement: 'الشروط العامة للاستخدام',
    applicationSettings: 'إعدادات التطبيق'
  },
  support: {
    title: 'الدعم',
    contact: 'اتصال',
    phone: 'رقم الهاتف',
    mail: 'عنوان البريد الإلكتروني',
    links: 'روابط مفيدة',
    webSite: 'موقعنا الإلكتروني',
    headOffice: 'المقر الرئيسي'
  }
}
